import { makeStyles } from '@material-ui/core/styles';

export const LoadingScreenStyle = makeStyles({
  fullPage: {
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: 'rgba(255, 255, 255, 1.0)',
  },
  fadeInTextStyle: {
    color: '#808080',
    fontFamily: 'Trebuchet MS',
    fontSize: 16,
    letterSpacing: 0,
    lineHeight: '19px',
    textAlign: 'center',
  },
  nextPage: {
    height: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: 'rgba(255, 255, 255, 1.0)',
  },
  spaceBetweenGifAndText: {
    marginBottom: 10,
  },
});
